<template>
    <div class="platform-icon-wrapper">
        <div class="platform-icon">
            <webIcon v-if="platform === 'web' || platform === 'web-visitor-ip'" color="black" />
            <SupsisIcon v-if="platform === 'supsis'" class="icon" />
            <whatsapp-icon v-if="platform === 'whatsapp'" :color="'#25D366'" />
            <gmail-icon v-if="platform === 'email'" />
            <InstagramIcon v-if="platform === 'instagram'" special-background-mode />
            <MessengerIcon v-if="platform === 'messenger'" class="icon" />
            <TelegramIcon v-if="platform === 'telegram'" class="icon" />
            <LinkedinIcon v-if="platform === 'linkedin'" class="icon" />
            <calendar-icon v-if="platform === 'calendar'" class="icon" />
            <MetaIcon v-if="platform === 'meta-leads'" class="icon" />
            <img
                v-if="platform === 'web-visitor'"
                src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                class="icon"
            />
        </div>
    </div>
</template>
<script>
import webIcon from "../../views/Pages/Visitors/components/svg/WebIcon.vue";
import whatsappIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import gmailIcon from "../../views/Pages/Mail/icons/MailIcon.vue";
import InstagramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import MessengerIcon from "../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TelegramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon";
import calendarIcon from "../../views/Pages/Chatbot/pages/integrations/svg/CalendarIcon.vue";
import MetaIcon from "../../views/Pages/Chatbot/pages/integrations/svg/MetaIcon.vue";
import SupsisIcon from "../../views/Pages/Chatbot/pages/integrations/svg/SupsisIcon.vue";
import LinkedinIcon from "../../views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";

export default {
    name: "PlatformIconViewer",
    props: {
        platform: {
            type: String,
            required: true,
            default: "web",
        },
    },
    components: {
        LinkedinIcon,
        MetaIcon,
        webIcon,
        whatsappIcon,
        gmailIcon,
        InstagramIcon,
        MessengerIcon,
        TelegramIcon,
        calendarIcon,
        SupsisIcon,
    },
    data() {
        return {};
    },
};
</script>
<style>
.platform-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    .platform-icon {
        width: 30px;
        height: 30px;
        .icon {
            width: 30px;
            height: 20px;
            object-fit: contain;
        }
    }
}
</style>
